import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-page29',
  templateUrl: './page29.component.html',
  styleUrls: ['./page29.component.css']
})
export class Page29Component implements OnInit {
  @Input() data: any;
  constructor() { }

  ngOnInit(): void {
  }

}
